import { useState, useEffect } from 'react';
import SlidingPane from 'react-sliding-pane';
import 'react-sliding-pane/dist/react-sliding-pane.css';
import Axios from '../../../config/axios';
import { message } from 'antd';
import Globals from '../../../config/globals';
import evitePng from '../../../img/evite_thumbnail.png';
import d2pLogo from '../../../img/D2P-logo.png';
import htmlPng from '../../../img/Thumb_HTML.PNG';
import jpgPng from '../../../img/Thumb_JPG.PNG';
import pdfPng from '../../../img/Thumb_PDF.PNG';
import thumbVideo from '../../../img/Thumb_Video.PNG';
import placeholderImg from '../../../img/sample_placeholder.png';

export function D2PLogoSlider({ showPane, showCode, hidePane }) {

    const [showPaneState, setShowPaneState] = useState(showPane);

    useEffect(() => {
        setShowPaneState(showPane);
    }, [showPane])


    // Loading state for each download button
    const [loadingBtn, setLoadingBtn] = useState({});

    const setLoading = (label, value) => {
        setLoadingBtn(prev => ({ ...prev, [label]: value }));
    };

    // Download D2P Logo handler
    const downloadD2PLogo = () => {
        setLoading('D2P Logo', true);
        try {
            // Create a link and trigger download
            const link = document.createElement('a');
            link.href = d2pLogo;
            link.setAttribute('download', 'D2P-logo.png');
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        } finally {
            setLoading('D2P Logo', false);
        }
    };

    return (
        <SlidingPane
            className='some-custom-class'
            overlayClassName='showCard'
            isOpen={showPaneState}
            title='Design-2-Part Logo'
            onRequestClose={hidePane}
            closeIcon={<i className="fas fa-chevron-right float-left"></i>}
            width="60%"
        >
            <div className="slide-pane-body scrollableDiv">
                <div className="card bg-light text-center border-0 shadow-sm d-flex flex-row" style={{ marginBottom: '0.25rem' }}>
                    <div className="p-2"> {/* reduced padding */}
                        <img
                            src={d2pLogo} // replace with your logo image variable
                            alt="Design-2-Part Logos"
                            className="mb-2"
                            style={{ width: 325, height: 123, objectFit: 'contain' }}
                        />
                        <div>
                            <button
                                className="btn btn-warning btn-sm"
                                onClick={downloadD2PLogo} // replace with your download handler
                                disabled={!!loadingBtn['Design-2-Part Logos']}
                            >
                                {loadingBtn['Design-2-Part Logos'] ? (
                                    <span>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Downloading...
                                    </span>
                                ) : (
                                    'Download'
                                )}
                            </button>
                        </div>
                    </div>

                    <div className="align-self-center p-2"> {/* reduced padding */}
                        <div style={{ fontSize: '15px', textAlign: 'left' }}>
                            <div style={{ marginBottom: 5 }}> {/* reduced spacing */}
                                <p style={{ marginBottom: '0.4rem', lineHeight: 1.3 }}>
                                    Official Design-2-Part logos for use in your show promotions.
                                </p>

                                <p style={{ marginBottom: '0.4rem', lineHeight: 1.3 }}>
                                    <strong>How to use:</strong>
                                </p>

                                <ul style={{ marginTop: 0, paddingLeft: '1.2rem', textAlign: 'left' }}>
                                    <li style={{ marginBottom: '0.25rem', lineHeight: 1.3 }}>
                                        Download the logo file
                                    </li>
                                    <li style={{ marginBottom: '0.25rem', lineHeight: 1.3 }}>
                                        Add it to your website, email signature, or marketing materials
                                    </li>
                                    <li style={{ marginBottom: '0.25rem', lineHeight: 1.3 }}>
                                        Use alongside exhibitor invites and promotions
                                    </li>
                                </ul>

                                <p style={{ marginTop: '0.5rem', lineHeight: 1.3 }}>
                                    <strong>Please do not alter logo colors or proportions</strong>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <div className="form-group col-12 padding-25-10">
                    <button className="btn btn-primary btn-lg margin-left-15" onClick={hidePane}>Close</button>
                </div>
            </div>
        </SlidingPane>
    );
}